import Component from '@glimmer/component'
import { service } from '@ember/service'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import { ErrorsImageApplicationError } from 'teacher-ui-client/components/errors/image-application-error'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import type LogoutService from 'teacher-ui-client/services/logout'

interface Signature {
  Element: HTMLDivElement
}

/**
 * For this page, the subscription-type is not known. Additionally there is no sidenav etc. so need to provide logout.
 */
export class ErrorsApplicationErrorPage extends Component<Signature> {
  @service logout!: LogoutService

  <template>
    <div data-test-errors-application-error-page class="text-dusty-black-300 space-y-2 text-center" ...attributes>
      <ErrorsImageApplicationError />
      <h2 data-test-application-error-title>
        {{t "components.errors.applicationError.title"}}
      </h2>
      <p class="text-xl" data-test-application-error-body>
        {{t "components.errors.applicationError.body" htmlSafe=true}}
      </p>

      {{! subcription-type agnostic logout button }}
      <div class="p-2">
        <UiButton
          data-test-errors-button-logout
          @appearance={{ButtonAppearance.blue}}
          {{on "click" this.logout.logoutAndRedirect}}
        >
          {{t "components.errors.buttonLogout"}}
        </UiButton>
      </div>
    </div>
  </template>
}

export default ErrorsApplicationErrorPage
